import { updateField } from 'vuex-map-fields'

const SET_CODING_SCHEDULE_REQUEST = (state, payload) => {
  state.codingScheduleRequest = payload
}

const SET_CODING_SCHEDULE_REQUESTS = (state, payload) => {
  state.codingScheduleRequests = payload
}

const SET_REVIEW_REQUESTS = (state, payload) => {
  state.reviewRequests = payload
}

const SET_INTERIM_REQUESTS = (state, payload) => {
  state.interimRequests = payload
}

const SET_ALL_REQUESTS = (state, payload) => {
  state.allRequests = payload
}

const CONCAT_ACUTE_CODERS = (state, payload) => {
  state.codingScheduleRequest.scheduleRequestsDetailsCoding = state.codingScheduleRequest.scheduleRequestsDetailsCoding.concat(payload)
}

const CONCAT_PRO_CODERS = (state, payload) => {
  state.codingScheduleRequest.scheduleRequestsDetailsCodingPro = state.codingScheduleRequest.scheduleRequestsDetailsCodingPro.concat(payload.scheduleRequestsDetailsCodingPro)
  state.codingScheduleRequest.scheduleRequestsSpecialtiesCodingPro = state.codingScheduleRequest.scheduleRequestsSpecialtiesCodingPro.concat(payload.scheduleRequestsSpecialtiesCodingPro)
}

const DELETE_ACUTE_CODERS = (state, payload) => {
  state.codingScheduleRequest.scheduleRequestsDetailsCoding = state.codingScheduleRequest.scheduleRequestsDetailsCoding.filter(x => {
    return !payload.some(y => y.id === x.id)
  })
}

const DELETE_PRO_CODERS = (state, payload) => {
  state.codingScheduleRequest.scheduleRequestsDetailsCodingPro = state.codingScheduleRequest.scheduleRequestsDetailsCodingPro.filter(x => {
    return !payload.scheduleRequestsDetailsCodingPro.some(y => y.id === x.id)
  })

  state.codingScheduleRequest.scheduleRequestsSpecialtiesCodingPro = state.codingScheduleRequest.scheduleRequestsSpecialtiesCodingPro.filter(x => {
    return !payload.scheduleRequestsSpecialtiesCodingPro.some(y => y.id === x.id)
  })
}

const UPDATE_ACUTE_CODERS = (state, payload) => {
  state.codingScheduleRequest.scheduleRequestsDetailsCoding = state.codingScheduleRequest.scheduleRequestsDetailsCoding.filter(x => {
    if (payload.length > 0) {
      return x.coderNumber !== payload[0].coderNumber
    } else {
      return true
    }
  })

  state.codingScheduleRequest.scheduleRequestsDetailsCoding = state.codingScheduleRequest.scheduleRequestsDetailsCoding.concat(payload)
  state.codingScheduleRequest.scheduleRequestsDetailsCoding.sort((a, b) => a.coderNumber - b.coderNumber)
}

const UPDATE_PRO_CODERS = (state, payload) => {
  // need to handle adds, updates and deletes here for a single coder number so we are deleting all rows for the coder
  // and then adding them back in with the latest data
  // and then sorting the array
  state.codingScheduleRequest.scheduleRequestsDetailsCodingPro = state.codingScheduleRequest.scheduleRequestsDetailsCodingPro.filter(x => {
    if (payload.scheduleRequestsDetailsCodingPro.length > 0) {
      return x.coderNumber !== payload.scheduleRequestsDetailsCodingPro[0].coderNumber
    } else {
      return true
    }
  })

  state.codingScheduleRequest.scheduleRequestsDetailsCodingPro = state.codingScheduleRequest.scheduleRequestsDetailsCodingPro.concat(payload.scheduleRequestsDetailsCodingPro)
  state.codingScheduleRequest.scheduleRequestsDetailsCodingPro.sort((a, b) => a.coderNumber - b.coderNumber)

  state.codingScheduleRequest.scheduleRequestsSpecialtiesCodingPro = state.codingScheduleRequest.scheduleRequestsSpecialtiesCodingPro.filter(x => {
    if (payload.scheduleRequestsSpecialtiesCodingPro.length > 0) {
      return x.coderNumber !== payload.scheduleRequestsSpecialtiesCodingPro[0].coderNumber
    } else {
      return true
    }
  })

  state.codingScheduleRequest.scheduleRequestsSpecialtiesCodingPro = state.codingScheduleRequest.scheduleRequestsSpecialtiesCodingPro.concat(payload.scheduleRequestsSpecialtiesCodingPro)
  state.codingScheduleRequest.scheduleRequestsSpecialtiesCodingPro.sort((a, b) => a.coderNumber - b.coderNumber)
}

const SET_SPECIALTIES = (state, payload) => {
  state.specialties = payload
}

const SET_AMBULATORY_SPECIALTIES_LOOKUP = (state, payload) => {
  state.ambulatorySpecialtiesLookup = payload
}

const SET_SCHEDULE_PERIODS = (state, payload) => {
  state.schedulePeriods = payload
}

export default {
  updateField,
  SET_CODING_SCHEDULE_REQUEST,
  SET_CODING_SCHEDULE_REQUESTS,
  SET_REVIEW_REQUESTS,
  CONCAT_ACUTE_CODERS,
  CONCAT_PRO_CODERS,
  DELETE_ACUTE_CODERS,
  DELETE_PRO_CODERS,
  UPDATE_ACUTE_CODERS,
  UPDATE_PRO_CODERS,
  SET_SPECIALTIES,
  SET_AMBULATORY_SPECIALTIES_LOOKUP,
  SET_INTERIM_REQUESTS,
  SET_SCHEDULE_PERIODS,
  SET_ALL_REQUESTS
}
